import { trackEvent } from '@intercom/messenger-js-sdk';
import { sessionStore } from '../Session/Store';

/**
 * Check if the current session is an impersonation session
 * @returns true if user is being impersonated, false otherwise
 */
function isImpersonatedSession(): boolean {
  const state = sessionStore.state;
  if (state.kind === 'present') {
    const impersonatorId = state.sessionData.impersonatingUserId.map(String).getOrElseValue('');
    return impersonatorId !== '';
  }
  return false;
}

/**
 * Track a custom event in Intercom
 * @param eventName - The name of the event to track
 * @param metadata - Optional metadata to attach to the event
 *
 * Note: Events are not tracked during impersonation sessions to avoid
 * polluting analytics data with admin/support activity.
 */
export function trackIntercomEvent(eventName: string, metadata?: Record<string, any>): void {
  try {
    // Skip tracking if user is being impersonated
    if (isImpersonatedSession()) {
      console.debug('Skipping Intercom event during impersonation:', eventName);
      return;
    }

    // Check if Intercom is loaded before attempting to track
    if (typeof window !== 'undefined' && window.Intercom) {
      trackEvent(eventName, metadata);
    } else {
      console.warn('Intercom not loaded, event not tracked:', eventName);
    }
  } catch (error) {
    console.warn('Failed to track Intercom event:', eventName, error);
  }
}
